import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { Select } from "antd";
// import { toast } from "react-toastify";
// import { ToastContainer } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { Toast } from "react-bootstrap";

interface AddTicketProps {
  teacherId: number;
  onSuccess: () => void;
}

interface OptionType {
  id: number;
  name: string;
}
interface OptionType1 {
  id: number;
  name: string;
  has_call_back_time: boolean;
}

interface ErrorToast {
  key: string;
  message: string;
}

const AddSedTicket = ({ teacherId, onSuccess }: AddTicketProps) => {
  const { Option } = Select;
  const { userPermissions, webApi } = useUserPermissions();
  const jwtToken = Cookies.get("authToken");
  const [categories, setCategories] = useState<OptionType[]>([]);
  const [subCategories, setSubCategories] = useState<OptionType1[]>([]);
  const [showCallback, setShowCallback] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>({});

  const [errorToasts, setErrorToasts] = useState<ErrorToast[]>([]);
  const [errors, setErrors] = useState<any>({});
  useEffect(() => {
    if (errorToasts.length === 0) return;
    const timeoutId = setTimeout(() => {
      setErrorToasts((prev) => prev.slice(1)); // remove oldest toast
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [errorToasts]);

  const handleCloseToast = (index: number) => {
    setErrorToasts((prev) => prev.filter((_, i) => i !== index));
  };

  const [formData, setFormData] = useState({
    category: "",
    sub_category: "",
    call_back_time: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await fetch(
        `${webApi}/sed/sed_ticket_category_dropdown_for_ticket_operations/`,
        options,
      );
      const data = await res.json();
      setCategories(data || []);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch sub categories based on category
  const fetchSubCategories = async (categoryId: string) => {
    try {
      const res = await fetch(
        `${webApi}/sed/sed_ticket_subcategory_dropdown_for_ticket_operations/?category=${categoryId}`,
        options,
      );
      const data = await res.json();
      setSubCategories(data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  //   useEffect(() => {
  //     if (formData.category) {
  //       fetchSubCategories(formData.category);
  //     }
  //   }, [formData.category]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategoryChange = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      category: value,
      sub_category: "", // reset subcategory
    }));

    fetchSubCategories(value);
  };

  const handleSubCategoryChange = (value: string) => {
    const selectedSubCategory = subCategories.find(
      (item) => item.id === Number(value),
    );

    const callbackRequired = selectedSubCategory?.has_call_back_time ?? false;

    setShowCallback(callbackRequired);

    setFormData((prev) => ({
      ...prev,
      sub_category: value,
      call_back_time: callbackRequired ? prev.call_back_time : "",
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      teacher: teacherId,
      category: formData.category,
      sub_category: formData.sub_category,
      call_back_time: showCallback ? formData.call_back_time : null,
      description: formData.description,
    };

    try {
      setLoading(true);

      const res = await fetch(
        `${webApi}/sed/sed_teacher_ticket_operations/${teacherId}/`,
        {
          method: "POST",
          headers: options.headers,
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (!res.ok) {
        setErrors(data);
        console.log("Error Data:", data);

        const messages: ErrorToast[] = [];

        for (const key in data) {
          const value = data[key];

          if (Array.isArray(value)) {
            value.forEach((msg: string) =>
              messages.push({ key, message: msg }),
            );
          } else if (typeof value === "string") {
            messages.push({ key, message: value });
          }
        }
        setErrorToasts(messages);
        return; // or throw new Error(...)
      }

      if (!res.ok) {
        setErrorMessage(data);
        return;
      }

      toast.success("Ticket created successfully.");

      setFormData({
        category: "",
        sub_category: "",
        call_back_time: "",
        description: "",
      });

      setSubCategories([]);
      setShowCallback(false);
      setErrorMessage({});

      toast.success("Ticket created successfully.");

      onSuccess();
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card border-0">
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {/* Category */}
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Category</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select Category"
                  value={formData.category || undefined}
                  onChange={handleCategoryChange}
                  showSearch
                  optionFilterProp="children"
                >
                  {categories.map((item) => (
                    <Option key={item.id} value={String(item.id)}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </div>
              {errorMessage.category && (
                <div className="text-danger ">{errorMessage.category[0]}</div>
              )}
            </div>

            {/* Sub Category */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Sub Category</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select Sub Category"
                  value={formData.sub_category || undefined}
                  onChange={handleSubCategoryChange}
                  disabled={!formData.category}
                  showSearch
                  optionFilterProp="children"
                >
                  {subCategories.map((item) => (
                    <Option key={item.id} value={String(item.id)}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </div>
              {errorMessage.sub_category && (
                <div className="text-danger ">
                  {errorMessage.sub_category[0]}
                </div>
              )}
            </div>

            {/* Callback */}
            {showCallback && (
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Call Back Time</label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    name="call_back_time"
                    value={formData.call_back_time}
                    onChange={handleInputChange}
                  />
                </div>
                {errorMessage.call_back_time && (
                  <div className="text-danger ">
                    {errorMessage.call_back_time[0]}
                  </div>
                )}
              </div>
            )}

            {/* Description */}
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter description"
                />
              </div>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            Save
          </button>
        </form>
      </div>
      {/*  Toast container */}
      <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 9999 }}>
        {errorToasts.map((toast, index) => (
          <Toast
            key={index}
            show={true}
            onClose={() => handleCloseToast(index)}
            className="colored-toast bg-danger-transparent mb-2"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <Toast.Header closeButton className="bg-danger text-white">
              <strong className="me-auto text-capitalize">{toast.key}</strong>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </div>
    </div>
  );
};

export default AddSedTicket;
